import { useTranslation } from 'react-i18next'

import { cn } from '@/lib/utils'

import { ServiceGroupGeneration } from '../../../../../../backend/schemas/src/service-groups'
import MarkdownRenderer from '../organisms/MarkdownRenderer'

type Props = {
  generation?: NonNullable<ServiceGroupGeneration['services']>[number]
  showPill?: boolean
}

const ServiceRecommendation = ({ generation, showPill = true }: Props) => {
  return (
    <div className="@container">
      {generation?.explanation && (
        <div
          className={cn(
            'p-5 bg-layer-2 w-full rounded-md flex justify-between items-start gap-4 border',
          )}
        >
          <div className="flex flex-col gap-6">
            {showPill && (
              <div className="@md:hidden">
                <ServiceRecommendationPill generation={generation} />
              </div>
            )}
            <MarkdownRenderer className="max-w-prose">{generation.explanation}</MarkdownRenderer>
          </div>
          {showPill && (
            <div className="hidden @md:block">
              <ServiceRecommendationPill generation={generation} />
            </div>
          )}
        </div>
      )}
    </div>
  )
}

export const ServiceRecommendationPill = ({
  generation,
}: {
  generation?: NonNullable<ServiceGroupGeneration['services']>[number]
}) => {
  const { t } = useTranslation()

  return (
    <div
      className={cn('bg-layer-3 w-28 p-2 px-3 rounded-md text-center whitespace-nowrap', {
        'bg-brand-funkia text-white': generation?.met === 'recommended',
        'bg-info-bg  text-info': generation?.met === 'uncertain',
        'bg-neutral-200 text-text-primary': generation?.met === 'not_recommended',
      })}
    >
      <h5>
        {generation?.met === 'recommended' && t('global.recommended')}
        {generation?.met === 'not_recommended' && t('global.notRecommended')}
        {generation?.met === 'uncertain' && t('global.uncertain')}
      </h5>
    </div>
  )
}

export default ServiceRecommendation
